// Store responsável por gerenciar os dados do usuário autenticado na aplicação.

import { defineStore } from "pinia";

export const useUserStore = defineStore("user", {
  state: () => {
    return {
      id: 0,
      email: '',
      nome: '',
      token: '',
      ieNome: '',
      funcao: '',
      sobre: '',
      isLogged: false, // Indica se o usuário está logado
      // isCommunity: false, // Indica que o usuário está acessando comunidades
      // communityId: null, // Contém o id da comunidade, caso o usuário tenha "entrado" em uma
      
      // inicia lendo do localStorage (se existir)
      isCommunity: JSON.parse(localStorage.getItem('isCommunity') || 'false'),
      communityId: localStorage.getItem('communityId'), // string ou null
    };
  },

  actions: {
    // Inicializa o estado do usuário a partir do localStorage, se existir.
    initialize() {
      try {
        const userData = localStorage.getItem('loggedUser');
        if (userData != null) {
          const parsed = JSON.parse(userData);

          // recupera imersão das chaves específicas
          const persistedIsCommunity = JSON.parse(localStorage.getItem('isCommunity') || 'false');
          const persistedCommunityId = localStorage.getItem('communityId');

          this.$state = {
            // estado padrão atual (inclui o que foi lido em state())
            ...this.$state,
            // dados de login persistidos
            ...parsed,
            // FORÇA o que está nas chaves dedicadas de comunidade
            isCommunity: persistedIsCommunity,
            communityId: persistedCommunityId,
          }
        };
      } catch (e) {
        this.reset();
      }
    },

    // Realiza o login do usuário e salva os dados no localStorage.
    login(id, email, nome, token, ieNome, funcao, sobre) {
      try {
        this.id = id;
        this.email = email;
        this.nome = nome;
        this.token = token;
        this.isLogged = true;
        this.isCommunity = false;
        this.communityId = null;
        localStorage.setItem('loggedUser', JSON.stringify(this.$state));
      } catch (e) {
        this.reset();
      }
    },

    // Realiza o logout do usuário e limpa os dados do localStorage.
    logout() {
      try {
        localStorage.removeItem('loggedUser');
      } catch (e) {
        // Se falhar, apenas reseta o estado
      }

      // garante que zera as chaves de imersão no localStorage também
      this.clearCommunityImmersion();

      this.reset();
    },

    // Reseta o estado do usuário para os valores iniciais.
    reset() {
      this.id = 0;
      this.email = '';
      this.nome = '';
      this.token = '';
      this.isLogged = false;
      this.isCommunity = false;
      this.communityId = null;
    },

    setCommunityImmersion(communityId) {
      this.isCommunity = true;
      this.communityId  = String(communityId);

      localStorage.setItem('isCommunity', 'true');
      localStorage.setItem('communityId', String(communityId));
    },

    clearCommunityImmersion() {
      this.isCommunity = false;
      this.communityId  = null;

      localStorage.removeItem('isCommunity');
      localStorage.removeItem('communityId');
    },
  },
});